import React from "react";

const Heading = ({ data, parameter }) => {
  return (
    <p className="lead">
      <span>{data[parameter].Name}</span>:
      <span>
        {data[parameter].data.length !== 0
          ? data[parameter].data[0].PARAM_VALUE.toFixed(
              data[parameter].PRECISION
            )
          : ""}
      </span>
    </p>
  );
};

export default Heading;
